define('flight-components/ImageGallery',[
  'App',
  'flight/lib/component',
  'flight-components/mixins/withModal'
],

function(App, defineComponent, withModal){

  var ImageGallery = function ImageGallery() {


    this.defaultAttrs({
      imageSelector: '.image-gallery__item'
    });


    this.showImage = function(ev, data) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      
      var imgSrc = $(data.el).attr('href');
      var imgCaption = $(data.el).attr('title');

      var imgFrame = '<div class="image-gallery__image-frame">' + $(data.el).html() + '</div>';
      
      if (typeof imgCaption !== 'undefined') {
        var imgCaption = '<div class="image-gallery__image-caption">' + $(data.el).attr('title') + '</div>';
      }

      
      this.activateModal({
        content: imgFrame + imgCaption,
        attr: {
          id: 'modal--image-gallery'
        }
      });
    };

    // this.getImage = function() {
    //   var self = this;
    //   self.trigger('uiModalGettingContent', opts);

    //   if (opts.hasOwnProperty('url')) {
    //     this.getHttpPage(opts.url, function(response) {
    //       self.trigger('uiModalGotContent', opts);
    //       callback.call(self, response.page.content);
    //     });
    //   } else {

    //     if (opts.content[0] === '#') {
    //       opts.content = $(opts.content).html();
    //     }

    //     self.trigger('uiModalGotContent', opts);
    //     callback.call(self, opts.content);
    //   }
    // };

   
    this.after('initialize', function() {

      var self = this;

      this.on('click', {
        'imageSelector': this.showImage 
      });

      // this.around('getModalContent', function() {
      //   console.log('get content');
      // });

    });

  };

  return defineComponent(ImageGallery, withModal);
});

